import { User as UserIcon } from "@tamagui/lucide-icons";
import { IconPill, Listbox } from "@medbillai/ui";
import type { Person } from "./records";

// No patient name normalises to an empty key, so it can stand for everyone.
const EVERYONE = "";
export const PersonPicker = ({
  people,
  person,
  onChange
}: {
  people: readonly Person[];
  person?: string;
  onChange: (person: string | undefined) => void;
}) => <Listbox label="Person" options={[{
  value: EVERYONE,
  label: "Everyone"
}, ...people.map(({
  key,
  label
}) => ({
  value: key,
  label
}))]} value={person ?? EVERYONE} onValueChange={value => onChange(value === EVERYONE ? undefined : value)} matchTriggerWidth={false} trigger={<IconPill variant="dropdown" avatar={{
  status: "info",
  icon: UserIcon
}} label={people.find(({
  key
}) => key === person)?.label ?? "Everyone"} aria-label="Person" />} data-sentry-element="Listbox" data-sentry-component="PersonPicker" data-sentry-source-file="PersonPicker.tsx">
    <Listbox.Options data-sentry-element="Listbox.Options" data-sentry-source-file="PersonPicker.tsx" />
  </Listbox>;